import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import {
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Button,
    Paper,
    Grid,
    Box,
    Container,
    IconButton,
} from "@mui/material";
import {
    retrieveFromMockReview,
    getQuestionsByIds,
    getMockQuestionsByIds,
    removeFromReview,
    getMockQuestionsByMockName
} from "../../../../../api/auth";

import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useSelector } from "react-redux";
import { getAllMainCategoriesWithQuestionCount, getSubscriptionStatus } from "../../../../../api/auth";
import { getSubcategoriesByMainCategoryWithQuestionCount } from "../../../../../api/auth";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useNavigate } from "react-router-dom";

const MockTestReviewPage = () => {
    const navigate = useNavigate();
    const [reviewData, setReviewData] = useState([]);
    const [mainCategories, setMainCategories] = useState([]);
    const [subCategories, setSubCategories] = useState({});
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [selectedSubcategoryId, setSelectedSubcategoryId] = useState("");
    const [isQuestionClicked, setIsQuestionClicked] = useState(false);

    const [desiredOutcomes, setDesiredOutcomes] = useState(null);

    const universityName = useSelector((state) => state.auth.universityName);
    const courseName = useSelector((state) => state.auth.courseName);
    const userId = useSelector((state) => state.auth.userId);
    const mock_name = useSelector((state) => state.questions.mock_name);
    const [subscriptionStatus, setSubscriptionStatus] = useState("");

    useEffect(() => {
        async function fetchSubscriptionStatus() {
            try {
                const status = JSON.parse(localStorage.getItem('subscription_status'));
                if (status.status === 'active') {
                    console.log('Subscription Status:', status.status);
                } else {
                    console.log('Subscription Status:', status.status);
                    navigate('/dashboard/payment');
                }
            } catch (error) {
                console.error("Error fetching subscription status:", error);
            }
        }

        fetchSubscriptionStatus();
    }, []);

    useEffect(() => {
        async function fetchMainCategories() {
            if (universityName && courseName) {
                try {
                    const response = await getAllMainCategoriesWithQuestionCount(
                        universityName,
                        courseName
                    );
                    setMainCategories(response.data.mainCategories);
                } catch (error) {
                    console.error("Error fetching main categories:", error);
                }
            }
        }
        fetchMainCategories();
    }, [universityName, courseName]);

    useEffect(() => {
        if (selectedCategoryId) {
            const fetchSubcategories = async () => {
                try {
                    const response =
                        await getSubcategoriesByMainCategoryWithQuestionCount(
                            selectedCategoryId,
                            userId
                        );
                    setSubCategories((prev) => ({
                        ...prev,
                        [selectedCategoryId]: response.data.subcategories,
                    }));
                } catch (error) {
                    console.error("Error fetching subcategories:", error);
                }
            };
            fetchSubcategories();
        }
    }, [selectedCategoryId, userId]);

    const handleCategoryChange = (event) => {
        setSelectedCategoryId(event.target.value);
        setSelectedSubcategoryId("");
    };

    const handleSubcategoryChange = (event) => {
        setSelectedSubcategoryId(event.target.value);
    };

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [detailedDialogOpen, setDetailedDialogOpen] = useState(false);

    const handleEntryClick = async (question) => {
    console.log("Clicked question:", question);

    const questionIndex = reviewData.findIndex(
        (q) => q.question_id === question.question_id
    );
    console.log("Question index in reviewData:", questionIndex);

    if (questionIndex !== -1) {
        setCurrentQuestionIndex(questionIndex);
    }

    try {
        const questionIds = [question.question_id];
        console.log("Fetching details for questionIds:", questionIds);

        const response = await getMockQuestionsByIds(questionIds, userId);
        console.log("Response from getMockQuestionsByIds:", response);

if (!response?.data?.mock_questions || !Array.isArray(response.data.mock_questions)) {
    console.error("No mock_questions array in response:", response.data);
    return;
}

const questionDetails = response.data.mock_questions[0];
console.log("Fetched questionDetails:", questionDetails);

        console.log("Fetched questionDetails:", questionDetails);

        if (!questionDetails) {
            console.error("questionDetails is undefined for question_id:", question.question_id);
            return;
        }

        const filteredChoices = questionDetails.Choices?.filter(
            choice => choice.option_id !== 9999
        ) || [];

        setDesiredOutcomes({
            ...questionDetails,
            Choices: filteredChoices,
            user_option_text: question.user_option_text,
            correct_option_text: question.correct_option_text,
            question_type: question.question_type,
            review_correct: question.correct,
        });

        setDetailedDialogOpen(true);
    } catch (error) {
        console.error("Error fetching question details:", error);
    }

    setIsQuestionClicked(true);
    setSelectedQuestion(question);
};


    const handleNextQuestion = () => {
        if (currentQuestionIndex < reviewData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const handlePreviousQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const fetchQuestionDetailsAtIndex = async (index) => {
        const question = reviewData[index];
        if (question) {
            handleEntryClick(question);
        }
    };

    useEffect(() => {
        const fetchReviewData = async () => {
            try {
                const catId = selectedCategoryId || "";
                const subcatId = selectedSubcategoryId || "";
                const response = await retrieveFromMockReview(userId, catId, subcatId);

                if (response.data.success) {
                    setReviewData(response.data.data);
                } else {
                    console.error("Unable to fetch review data");
                }
            } catch (error) {
                console.error("Error fetching review data:", error);
            }
        };

        fetchReviewData();
    }, [userId, selectedCategoryId, selectedSubcategoryId]);

    const handleGoToQuestion = async () => {
        if (selectedQuestion) {
            try {
                const questionIds = [selectedQuestion.question_id];
                const response = await getQuestionsByIds(questionIds);

                const questionDetails = response.data.questions[0];

                // Filter out choices with option_id 9999
                const filteredChoices = questionDetails.Choices?.filter(
                    choice => choice.option_id !== 9999
                ) || [];

                setDesiredOutcomes({
                    ...questionDetails,
                    Choices: filteredChoices,
                    user_option_text: selectedQuestion.user_option_text,
                    correct_option_text: selectedQuestion.correct_option_text,
                    question_type: selectedQuestion.question_type,
                    review_correct: selectedQuestion.correct,
                });

                setDetailedDialogOpen(true);
            } catch (error) {
                console.error("Error fetching question details:", error);
            }
        }
    };

    const handleRemoveFromList = async () => {
        if (selectedQuestion) {
            try {
                const response = await removeFromReview(
                    userId,
                    selectedQuestion.question_id
                );
                if (response.data.success) {
                    setReviewData((prevData) =>
                        prevData.filter(
                            (entry) => entry.question_id !== selectedQuestion.question_id
                        )
                    );
                    setDetailedDialogOpen(false);
                    setDesiredOutcomes(null);
                } else {
                    console.error("Unable to remove question from the list");
                }
            } catch (error) {
                console.error("Error removing question from the list:", error);
            }
        }
    };

    const handleClose = () => {
        setSelectedQuestion(null);
    };

    const handleDetailedDialogClose = () => {
        setDetailedDialogOpen(false);
        setDesiredOutcomes(null);
        setCurrentQuestionIndex(-1);
        setIsQuestionClicked(false);
    };

    useEffect(() => {
        if (
            currentQuestionIndex >= 0 &&
            currentQuestionIndex < reviewData.length &&
            isQuestionClicked
        ) {
            const question = reviewData[currentQuestionIndex];
            if (question) {
                handleEntryClick(question);
            }
        }
    }, [currentQuestionIndex, reviewData, isQuestionClicked]);

    return (
        <Box
            component="main"
            sx={{
                backgroundColor: "rgb(249, 249, 249)",
                flexGrow: 1,
                height: "100vh",
                overflow: "auto",
                p: 2,
            }}
        >
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Review
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Paper
                            elevation={1}
                            sx={{
                                padding: "10px",
                                height: "600px",
                                overflowY: "auto",
                            }}
                        >
                            {reviewData.length > 0 ? (
                                <div>
                                    {reviewData.map((entry, index) => (
                                        <Paper
                                            key={index}
                                            onClick={() => handleEntryClick(entry)}
                                            elevation={0}
                                            square={true}
                                            sx={{
                                                minHeight: "100px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                padding: "10px",
                                                marginBottom: "10px",
                                                cursor: "pointer",
                                                backgroundColor: "transparent",
                                                ...(entry.correct
                                                    ? {
                                                        borderColor: "#4caf50",
                                                        backgroundColor: "#e8f5e9",
                                                        border: "1px solid rgba(0, 0, 0, 0.1)",
                                                    }
                                                    : {
                                                        borderColor: "#ff5252",
                                                        backgroundColor: "#ffebee",
                                                        border: "1px solid rgba(0, 0, 0, 0.1)",
                                                    }),
                                                "&:hover": {
                                                    backgroundColor: entry.correct
                                                        ? "#c8e6c9"
                                                        : "#ffcdd2",
                                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                },
                                            }}
                                        >
                                            <Typography variant="body1" sx={{ flexGrow: 1 }}>
                                                {index + 1}. {entry.question_text}
                                            </Typography>
                                            {entry.correct ? (
                                                <CheckCircleOutlineIcon style={{ color: "green" }} />
                                            ) : (
                                                <HighlightOffIcon style={{ color: "red" }} />
                                            )}
                                        </Paper>
                                    ))}
                                </div>
                            ) : (
                                <Box sx={{ textAlign: "center", padding: "20px" }}>
                                    <Typography variant="h6">No Questions Available.</Typography>
                                    <Typography variant="subtitle1">
                                        Mock questions you have completed will show here
                                    </Typography>
                                </Box>
                            )}
                        </Paper>
                    </Grid>
                </Grid>

                {desiredOutcomes && (
                    <Dialog
                        open={detailedDialogOpen}
                        onClose={handleDetailedDialogClose}
                        fullWidth
                        maxWidth="md"
                    >
                        <DialogTitle>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    color="black"
                                    margin="8px"
                                >
                                    Question: {desiredOutcomes.question_text}
                                </Typography>
                                <IconButton onClick={handleDetailedDialogClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </DialogTitle>
                        <DialogContent>
                            {(desiredOutcomes.type >= 2 ||
                                desiredOutcomes.question_type >= 2) ? (
                                <>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            m: 1,
                                            backgroundColor: desiredOutcomes.review_correct
                                                ? "#e8f5e9"
                                                : "#ffebee",
                                            border: `1px solid ${
                                                desiredOutcomes.review_correct
                                                    ? "#4caf50"
                                                    : "#ff5252"
                                            }`,
                                        }}
                                    >
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            Your answer
                                        </Typography>
                                        <Typography variant="body1">
                                            {desiredOutcomes.user_option_text ||
                                                "No answer recorded"}
                                        </Typography>
                                    </Paper>
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 2,
                                            m: 1,
                                            backgroundColor: "#e8f5e9",
                                            border: "1px solid #4caf50",
                                        }}
                                    >
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            Correct answer
                                        </Typography>
                                        <Typography variant="body1">
                                            {desiredOutcomes.correct_option_text ||
                                                desiredOutcomes.Choices?.find(
                                                    (c) => c.is_correct
                                                )?.option_text ||
                                                "Not available"}
                                        </Typography>
                                    </Paper>
                                </>
                            ) : (
                                desiredOutcomes.Choices?.map((choice, index) => (
                                <Paper
                                    key={index}
                                    elevation={0}
                                    sx={{
                                        p: 2,
                                        m: 1,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        backgroundColor: choice.is_correct ? "#e8f5e9" : "#ffebee",
                                        border: `1px solid ${choice.is_correct ? "#4caf50" : "#ff5252"
                                            }`,
                                        ...(choice.option_text ===
                                            desiredOutcomes.user_option_text && {
                                            border: `2px dashed ${choice.is_correct ? "#4caf50" : "#ff5252"
                                                }`,
                                        }),
                                        "&:hover": {
                                            backgroundColor: choice.is_correct
                                                ? "#c8e6c9"
                                                : "#ffcdd2",
                                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                        },
                                        transition:
                                            "background-color 0.3s ease, box-shadow 0.3s ease",
                                    }}
                                >
                                    <Typography variant="subtitle1">
                                        Option {index + 1}:
                                    </Typography>
                                    <Typography variant="body1">{choice.option_text}</Typography>
                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                        Explanations will be given in the webinar
                                    </Typography>
                                    {choice.option_text === desiredOutcomes.user_option_text && (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: choice.is_correct ? "#4caf50" : "#ff5252",
                                                mt: 1,
                                            }}
                                        >
                                            You Selected
                                        </Typography>
                                    )}
                                </Paper>
                            )))}
                            
                        </DialogContent>
                        <Box display="flex" justifyContent="space-between" p={2}>
                            {currentQuestionIndex > 0 && (
                                <IconButton
                                    onClick={handlePreviousQuestion}
                                    aria-label="previous"
                                >
                                    <ArrowBackIosIcon />
                                </IconButton>
                            )}
                            {currentQuestionIndex < reviewData.length - 1 && (
                                <IconButton onClick={handleNextQuestion} aria-label="next">
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )}
                        </Box>
                    </Dialog>
                )}
            </Container>
        </Box>
    );
};

export default MockTestReviewPage;